<template>
    
    <div class="section text-center mt-2 mb-2" v-if="loading_list">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>
    <div class="section mt-2 mb-2" v-if="!loading_list">
    <div class="section-title mal-text">A. {{$t('name_address')}}</div>
        <div class="card">
            <div class="card-body">
                <Form @submit="storeBasicInfo" :validation-schema="schema" enctype='multipart/form-data'>
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="label mal-text" for="text4b">{{$t('name')}}</label>
                            <Field :disabled="disable_all" name="name" type="text" class="form-control" id="name"
                                placeholder="" v-model="name" />
                        </div>
                        <ErrorMessage name="name" class="error-feedback" />
                    </div>

                    <div class="form-group boxed">
                        <div class="input-wrapper row">
                            <label class="label mal-text" for="dob">{{$t('dob_year')}}</label>
                            <div class="form-group col-12" style="width:100% !important;">
                                <div class="input-wrapper">
                                    <Field :disabled="disable_all" as="select" class="form-control custom-select"
                                        v-model="dob_year" name="dob_year" id="select4">
                                        <option v-for="item in years" :value="item" v-bind:key="item">
                                            {{ item }}</option>
                                    </Field>
                                </div>
                            </div>
                        </div>
                        <ErrorMessage name="dob" class="error-feedback" />
                    </div>

                    <div class="form-group boxed">
                        <div class="input-wrapper row">
                            <div class="form-group col-4" style="width:40% !important;">
                                <div class="input-wrapper">
                                    <label class="label mal-text" for="country_code">{{$t('mobile')}}</label>
                                    <Field :disabled="disable_all" as="select" class="form-control custom-select"
                                        v-model="country_code" name="country_code" id="select4">
                                        <option v-for="item in country_code_list" :value="item.item_value"
                                            v-bind:key="item.item_value">
                                            {{ 
                                                locale === 'en' ? item.name :
                                                locale === 'ml' ? item.name_mal :
                                                locale === 'ta' ? (item.name_ta || item.name) :
                                                locale === 'kn' ? (item.name_kn || item.name) :
                                                item.name
                                            }}
                                            </option>
                                    </Field>
                                </div>
                            </div>
                            <div class="form-group mobile-field col-7" style="width:60%">
                                <div class="input-wrapper">
                                    <Field :disabled="disable_all" name="mobile_number" v-model="mobile_number"
                                        type="number" id="mobile_number" class="form-control" placeholder=""
                                        @input="validateMobileInput($event, 'mobile')" 
                                        @keyup="validateMobileInput($event, 'mobile')"
                                        @paste="validateMobileInput($event, 'mobile')" />
                                </div>
                            </div>
                            <ErrorMessage name="mobile_number" class="error-feedback" />
                            <span class="text-danger">{{$t('mobile_update_warning')}}</span>
                        </div>
                    </div>

                    <div class="form-group boxed">
                        <div class="input-wrapper row">
                            <div class="form-group col-4" style="width:40% !important;">
                                <div class="input-wrapper">
                                    <label class="label mal-text" for="country_code">{{$t('whatsapp')}}</label>
                                    <Field :disabled="disable_all" as="select" class="form-control custom-select"
                                        v-model="country_code_whatsapp" name="country_code_whatsapp" id="select4">
                                        <option v-for="item in country_code_list" :value="item.item_value"
                                            v-bind:key="item.item_value">
                                            {{ 
                                                locale === 'en' ? item.name :
                                                locale === 'ml' ? item.name_mal :
                                                locale === 'ta' ? (item.name_ta || item.name) :
                                                locale === 'kn' ? (item.name_kn || item.name) :
                                                item.name
                                            }}
                                            </option>
                                    </Field>
                                </div>
                            </div>
                            <div class="form-group mobile-field col-7" style="width:60%">
                                <div class="input-wrapper">
                                    <Field :disabled="disable_all" name="whatsapp_number" v-model="whatsapp_number"
                                        type="number" id="whatsapp_number" class="form-control" placeholder=""
                                        @input="validateMobileInput($event, 'whatsapp')"
                                        @keyup="validateMobileInput($event, 'whatsapp')"
                                        @paste="validateMobileInput($event, 'whatsapp')" />
                                </div>
                            </div>
                            <ErrorMessage name="whatsapp_number" class="error-feedback" />
                        </div>
                    </div>

                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="label mal-text" for="text4b">{{$t('email')}}</label>
                            <Field :disabled="disable_all" name="email" type="email" class="form-control" id="email"
                                placeholder="" v-model="email" />
                        </div>
                        <ErrorMessage name="email" class="error-feedback" />
                    </div>

                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="label mal-text" for="text4b">{{$t('blood_group')}}</label>
                            <Field :disabled="disable_all" as="select" class="form-control custom-select"
                                v-model="blood_group" name="blood_group" id="select4">
                                <option v-for="item in blood_group_list" :value="item.id" v-bind:key="item.id">
                                    {{ 
                                        locale === 'en' ? item.name :
                                        locale === 'ml' ? item.name_mal :
                                        locale === 'ta' ? (item.name_ta || item.name) :
                                        locale === 'kn' ? (item.name_kn || item.name) :
                                        item.name
                                    }}
                                    </option>
                            </Field>
                        </div>
                        <ErrorMessage name="blood_group" class="error-feedback" />
                    </div>

                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="label mal-text" for="text4b">{{$t('blood_donation_willing')}}</label>
                            <div class="form-check mb-1 col-4">
                                <Field :disabled="disable_all" class="form-check-input" type="radio"
                                    name="blood_donation_willing" id="bloodDonationYes" v-model="blood_donation_willing"
                                    value="Yes" />
                                <label class="form-check-label" for="bloodDonationYes">
                                    {{$t('yes')}}
                                </label>
                            </div>
                            <div class="form-check mb-1 col-5">
                                <Field :disabled="disable_all" class="form-check-input" type="radio"
                                    name="blood_donation_willing" id="bloodDonationNo" v-model="blood_donation_willing"
                                    value="No" />
                                <label class="form-check-label" for="bloodDonationNo">
                                    {{$t('no')}}
                                </label>
                            </div>
                        </div>
                        <ErrorMessage name="blood_donation_willing" class="error-feedback" />
                    </div>

                    <!-- <div class="form-group boxed" v-if="blood_donation_willing === 'Yes'">
                        <div class="input-wrapper">
                            <label class="label mal-text" for="last_blood_donation_date">{{$t('last_blood_donation_date')}}</label>
                                തീയതി</label>
                            <Field :disabled="disable_all" name="last_blood_donation_date" type="date"
                                class="form-control" id="last_blood_donation_date" v-model="last_blood_donation_date" />
                        </div>
                        <ErrorMessage name="last_blood_donation_date" class="error-feedback" />
                    </div> -->

                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="label mal-text" for="text4b">{{$t('nri_status')}}</label>
                            <div class="form-check mb-1 col-4">
                                <Field :disabled="disable_all" class="form-check-input" type="radio" name="nri_status"
                                    id="flexRadioDefault1" v-model="nri_status" value="No" />
                                <label class="form-check-label" for="flexRadioDefault1">
                                    {{$t('no')}}
                                </label>
                            </div>
                            <div class="form-check mb-1 col-5">
                                <Field :disabled="disable_all" class="form-check-input" type="radio" name="nri_status"
                                    id="flexRadioDefault2" v-model="nri_status" value="Yes" />
                                <label class="form-check-label" for="flexRadioDefault2">
                                    {{$t('nri_yes')}}
                                </label>
                            </div>
                            <div class="form-check mb-1 col-12">
                                <Field :disabled="disable_all" class="form-check-input" type="radio" name="nri_status"
                                    id="flexRadioDefault3" v-model="nri_status" value="NotNow" />
                                <label class="form-check-label" for="flexRadioDefault3">
                                    {{$t('nri_notnow')}}
                                </label>
                            </div>
                        </div>
                        <ErrorMessage name="panjayath" class="error-feedback" />
                    </div>

                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="label mal-text" for="text4b">{{$t('current_location')}}</label>
                            <div class="form-check mb-1 col-4">
                                <Field :disabled="disable_all" class="form-check-input" type="radio"
                                    name="current_location_type" id="locationInState" v-model="current_location_type"
                                    value="in_state" />
                                <label class="form-check-label" for="locationInState">
                                    {{$t('in_state')}}
                                </label>
                            </div>
                            <div class="form-check mb-1 col-5">
                                <Field :disabled="disable_all" class="form-check-input" type="radio"
                                    name="current_location_type" id="locationOutsideState"
                                    v-model="current_location_type" value="outside_state" />
                                <label class="form-check-label" for="locationOutsideState">
                                    {{$t('outside_state_india')}}
                                </label>
                            </div>
                            <div class="form-check mb-1 col-5">
                                <Field :disabled="disable_all" class="form-check-input" type="radio"
                                    name="current_location_type" id="locationAbroad" v-model="current_location_type"
                                    value="abroad" />
                                <label class="form-check-label" for="locationAbroad">
                                    {{$t('abroad')}}
                                </label>
                            </div>
                        </div>
                        <ErrorMessage name="current_location_type" class="error-feedback" />
                    </div>

                    <!-- In State - Cluster Selection -->
                    <!-- <div class="form-group boxed" v-if="current_location_type === 'in_state'">
                        <div class="input-wrapper">
                            <label class="label mal-text" for="current_cluster">താമസിക്കുന്ന പ്രദേശം അല്ലെങ്കിൽ ഏറ്റവും അടുത്ത സ്ഥലം തിരഞ്ഞെടുക്കുക</label>
                            <Field :disabled="disable_all" as="select" class="form-control custom-select" v-model="current_cluster"
                                name="current_cluster" id="current_cluster">
                                <option value="">ജില്ല തിരഞ്ഞെടുക്കുക</option>
                                <option v-for="district in district_list" :value="district.id" v-bind:key="district.id">
                                    {{ district.name }}</option>
                            </Field>
                        </div>
                        <ErrorMessage name="current_cluster" class="error-feedback" />
                    </div> -->

                    <!-- Outside State - State and District Selection -->
                    <div v-if="current_location_type === 'outside_state'">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="label" for="outside_state">{{$t('select_state')}}</label>
                                <Field :disabled="disable_all" as="select" class="form-control custom-select"
                                    v-model="outside_state" name="outside_state" id="outside_state">
                                    <option value="">{{$t('select_state')}}</option>
                                    <option v-for="state in india_state_list" :value="state.id" v-bind:key="state.id">
                                        {{ 
                                            locale === 'en' ? (state.name ? state.name : state.name_mal) :
                                            locale === 'ml' ? state.name_mal :
                                            locale === 'ta' ? (state.name_ta || state.name) :
                                            locale === 'kn' ? (state.name_kn || state.name) :
                                            state.name
                                        }}
                                    </option>
                                </Field>
                            </div>
                            <ErrorMessage name="outside_state" class="error-feedback" />
                        </div>
                    </div>

                    <!-- Abroad - Country Selection -->
                    <div v-if="current_location_type === 'abroad'">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="label" for="abroad_country">{{$t('select_country')}}</label>
                                <Field :disabled="disable_all" as="select" class="form-control custom-select"
                                    v-model="abroad_country" name="abroad_country" id="abroad_country"
                                    @change="onAbroadCountryChange($event.target.value)">
                                    <option value="">{{$t('select_country')}}</option>
                                    <option v-for="country in abroad_country_list" :value="country.id"
                                        v-bind:key="country.id">
                                        {{ 
                                            locale === 'en' ? (country.name ? country.name : country.name_mal) :
                                            locale === 'ml' ? country.name_mal :
                                            locale === 'ta' ? (country.name_ta || country.name) :
                                            locale === 'kn' ? (country.name_kn || country.name) :
                                            country.name
                                        }}
                                    </option>
                                </Field>
                            </div>
                            <ErrorMessage name="abroad_country" class="error-feedback" />
                        </div>

                        <div class="form-group boxed" v-if="abroad_country && abroad_city_list.length > 0">
                            <div class="input-wrapper">
                                <label class="label" for="abroad_city">{{$t('select_abroad_city')}}</label>
                                <Field :disabled="disable_all" as="select" class="form-control custom-select"
                                    v-model="abroad_city" name="abroad_city" id="abroad_city">
                                    <option value="">{{$t('select_abroad_city')}}</option>
                                    <option v-for="city in abroad_city_list" :value="city.name" v-bind:key="city.name">
                                        {{ 
                                            locale === 'en' ? (city.name ? city.name : city.name_mal) :
                                            locale === 'ml' ? city.name_mal :
                                            locale === 'ta' ? (city.name_ta || city.name) :
                                            locale === 'kn' ? (city.name_kn || city.name) :
                                            city.name
                                        }}
                                    </option>
                                </Field>
                            </div>
                            <ErrorMessage name="abroad_city" class="error-feedback" />
                        </div>

                        <div class="form-group boxed" v-if="abroad_country && abroad_city_list.length === 0">
                            <div class="input-wrapper">
                                <label class="label" for="abroad_city_text">{{$t('enter_abroad_city')}}</label>
                                <Field :disabled="disable_all" name="abroad_city" type="text" class="form-control"
                                    id="abroad_city_text" v-model="abroad_city"
                                    :placeholder="$t('enter_city_name')" />
                            </div>
                            <ErrorMessage name="abroad_city" class="error-feedback" />
                        </div>
                    </div>

                    <div class="section-heading text-center">
                    <div class="listview-title mt-0">{{$t('permanent_address_india')}}</div>
                    </div>
                    <hr class="hr-line">

                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="label mal-text" for="text4b">{{$t('address')}}</label>
                            <Field :disabled="disable_all" name="house_name" type="text" class="form-control"
                                id="house_name" v-model="house_name" placeholder="" />
                        </div>
                        <ErrorMessage name="house_name" class="error-feedback" />
                    </div>

                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="label mal-text" for="text4b">{{$t('post_office')}}</label>
                            <Field :disabled="disable_all" name="post_office" type="text" class="form-control"
                                id="post_office" v-model="post_office" placeholder="" />
                        </div>
                        <ErrorMessage name="post_office" class="error-feedback" />
                    </div>

                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="label mal-text" for="text4b">{{$t('pin_code')}}</label>
                            <Field :disabled="disable_all" name="pin_code" type="text" class="form-control"
                                id="pin_code" v-model="pin_code" placeholder="" />
                        </div>
                        <ErrorMessage name="pin_code" class="error-feedback" />
                    </div>

                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="label mal-text" for="text4b">{{$t('country')}}</label>
                            <Field :disabled="disable_all" as="select" class="form-control custom-select"
                                v-model="country" name="country" id="select4">
                                <option v-for="item in country_list" :value="item.id" v-bind:key="item.id">
                                    {{
                                        locale === 'ml' ? item.name_mal :
                                        locale === 'ta' ? (item.name_ta || item.name) :
                                        locale === 'kn' ? (item.name_kn || item.name) :
                                        item.name + (item.name_mal ? ' (' + item.name_mal + ')' : '')
                                    }}
                                </option>
                            </Field>
                        </div>
                        <ErrorMessage name="country" class="error-feedback" />
                    </div>

                    <div class="form-group boxed" v-if="country == '91'">
                        <div class="input-wrapper">
                            <label class="label mal-text" for="text4b">{{$t('state')}}</label>
                            <Field :disabled="disable_all" as="select" class="form-control custom-select"
                                v-model="state" name="state" id="select4"
                                @change="onStateChange($event.target.value, false)">
                                <option v-for="item in state_list" :value="item.id" v-bind:key="item.id">
                                    {{ 
                                        locale === 'ml' ? item.name_mal :
                                        locale === 'ta' ? (item.name_ta || item.name) :
                                        locale === 'kn' ? (item.name_kn || item.name) :
                                        item.name + (item.name_mal ? ' (' + item.name_mal + ')' : '')
                                    }}
                                </option>
                            </Field>
                        </div>
                        <ErrorMessage name="state" class="error-feedback" />
                    </div>

                    <div class="form-group boxed"
                        v-if="country == '91' && (state == '94' || state == '529' || state == '541')">
                        <div class="input-wrapper">
                            <label class="label mal-text" for="text4b">{{$t('district')}}</label>
                            <Field :disabled="disable_all" as="select" class="form-control custom-select"
                                v-model="district" name="district" id="select4" @change="onDistrictChange">
                                <option v-for="item in district_list" :value="item.id" v-bind:key="item.id">
                                    {{ 
                                        locale === 'en' ? item.name + (item.name_mal ? ' (' + item.name_mal + ')' : '') :
                                        locale === 'ml' ? item.name_mal :
                                        locale === 'ta' ? (item.name_ta || item.name) :
                                        locale === 'kn' ? (item.name_kn || item.name) :
                                        item.name
                                    }}
                                    </option>
                            </Field>
                        </div>
                        <ErrorMessage name="district" class="error-feedback" />
                    </div>

                    <div class="form-group boxed"
                        v-if="country == '91' && (state == '94' || state == '529' || state == '541') && district">
                        <div class="input-wrapper">
                            <label class="label mal-text" for="text4b">{{$t('select_local_body')}}</label>
                            <div class="form-check mb-1 col-4" v-for="item in local_body_list"
                                :set="panj_id = 'flexRadioDefault' + item.id" :value="item.id" v-bind:key="item.id">
                                <Field :disabled="disable_all" class="form-check-input" type="radio"
                                    name="flexRadioDefault" :id="panj_id" v-model="local_body_type" :value="item.id" />
                                <label class="form-check-label" :for="panj_id">
                                    {{
                                        locale === 'en' ? item.name :
                                        locale === 'ml' ? item.name_mal :
                                        locale === 'ta' ? (item.name_ta || item.name) :
                                        locale === 'kn' ? (item.name_kn || item.name) :
                                        item.name
                                    }}
                                </label>
                            </div>
                        </div>
                        <ErrorMessage name="panjayath" class="error-feedback" />
                    </div>

                    <!-- Updated Panchayath selection for permanent address -->
                    <div class="form-group boxed"
                        v-if="country == '91' && (state == '94' || state == '529' || state == '541') && district && panchayaths.length">
                        <div class="input-wrapper">
                            <label class="label mal-text" for="panchayath">
                                {{$t('select_panchayath_type')}}
                            </label>
                            <Field :disabled="disable_all" as="select" class="form-control custom-select"
                                v-model="selectedPanchayath" name="panchayath" id="panchayath"
                                @change="onPanchayathChange">
                                <option value="">
                                    {{ local_body_type == 827 ? "---":local_body_type==828?"---":"---"}}
                                </option>
                                <option v-for="p in panchayaths" :key="p.id" :value="p.id">{{ locale === 'en' ? (p.name_eng ? p.name_eng : p.name) : p.name }}</option>
                            </Field>
                        </div>
                        <ErrorMessage name="panchayath" class="error-feedback" />
                    </div>

                    <div class="form-group boxed" v-if="selectedPanchayath && wards.length">
                        <div class="input-wrapper">
                            <label class="label mal-text" for="ward">{{$t('select_nearest_place')}}</label>
                            <Field :disabled="disable_all" as="select" class="form-control custom-select"
                                v-model="selectedWard" name="selectedWard" id="ward">
                                <option value="">---</option>
                                <option v-for="w in wards" :key="w.id" :value="w.id">{{ w.name }}</option>
                            </Field>
                        </div>
                        <ErrorMessage name="selectedWard" class="error-feedback" />
                    </div>

                    <!-- Same address checkbox -->
                    <div class="form-check mb-1">
                        <input :disabled="disable_all" type="checkbox" class="form-check-input" id="customCheckb1"
                            v-model="same_adress" @change="clickSameAddress($event)">
                        <label class="form-check-label mal-text" for="customCheckb1">{{$t('same_address')}}</label>
                    </div>

                    <!-- Current/Temporary address section -->
                    <div v-if="!same_adress">
                        <div class="section-heading text-center">
                            <div class="listview-title mt-0">{{$t('current_address')}}</div>
                        </div>
                        <hr class="hr-line">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="label mal-text" for="text4b">{{$t('house_name')}}</label>
                            <label class="label mal-text" for="text4b">{{$t('country')}}</label>
                            <label class="label mal-text" for="text4b">{{$t('state')}}</label>
                            <label class="label mal-text" for="text4b">{{$t('district')}}</label>
                            <label class="label mal-text" for="text4b">{{$t('select_local_body')}}</label>
                                <Field :disabled="disable_all" name="t_house_name" type="text" class="form-control"
                                    id="t_house_name" v-model="t_house_name" placeholder="" />
                            </div>
                            <ErrorMessage name="t_house_name" class="error-feedback" />
                        </div>

                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="label mal-text" for="text4b">{{$t('post_office')}}</label>
                                <Field :disabled="disable_all" name="t_post_office" type="text" class="form-control"
                                    id="t_post_office" v-model="t_post_office" placeholder="" />
                            </div>
                            <ErrorMessage name="t_post_office" class="error-feedback" />
                        </div>

                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="label mal-text" for="text4b">{{$t('pin_code')}}</label>
                                <Field :disabled="disable_all" name="t_pin_code" type="text" class="form-control"
                                    id="t_pin_code" v-model="t_pin_code" placeholder="" />
                            </div>
                            <ErrorMessage name="t_pin_code" class="error-feedback" />
                        </div>

                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="label mal-text" for="text4b">{{$t('country')}}</label>
                                <Field :disabled="disable_all" as="select" class="form-control custom-select"
                                    v-model="t_country" name="t_country" id="select4"
                                    @change="onTCountryChange($event.target.value)">
                                    <option v-for="item in t_country_list" :value="item.id" v-bind:key="item.id">
                                        {{ locale === 'ml' ? item.name_mal : item.name + (item.name_mal ? ' (' + item.name_mal + ')' : '') }}
                                    </option>
                                </Field>
                            </div>
                            <ErrorMessage name="t_country" class="error-feedback" />
                        </div>

                        <div class="form-group boxed" v-if="t_country == '91'">
                            <div class="input-wrapper">
                                <label class="label mal-text" for="text4b">{{$t('state')}}</label>
                                <Field :disabled="disable_all" as="select" class="form-control custom-select"
                                    v-model="t_state" name="t_state" id="select4"
                                    @change="onStateChange($event.target.value, true)">
                                    <option v-for="item in t_state_list" :value="item.id" v-bind:key="item.id">
                                        {{ locale === 'ml' ? item.name_mal : item.name + (item.name_mal ? ' (' + item.name_mal + ')' : '') }}
                                    </option>
                                </Field>
                            </div>
                            <ErrorMessage name="t_state" class="error-feedback" />
                        </div>

                        <div class="form-group boxed"
                            v-if="t_country == '91' && (t_state == '94' || t_state == '529' || t_state == '541')">
                            <div class="input-wrapper">
                                <label class="label mal-text" for="text4b">{{$t('district')}}</label>
                                <Field :disabled="disable_all" as="select" class="form-control custom-select"
                                    v-model="t_district" name="t_district" id="select4" @change="onTDistrictChange">
                                    <option v-for="item in t_district_list" :value="item.id" v-bind:key="item.id">
                                        {{
                                        locale === 'en' ? item.name :
                                            locale === 'ml' ? item.name_mal :
                                            locale === 'ta' ? (item.name_ta || item.name) :
                                            locale === 'kn' ? (item.name_kn || item.name) :
                                            item.name
                                        }}</option>
                                </Field>
                            </div>
                            <ErrorMessage name="t_district" class="error-feedback" />
                        </div>

                        <div class="form-group boxed"
                            v-if="t_country == '91' && (t_state == '94' || t_state == '529' || t_state == '541') && t_district">
                            <div class="input-wrapper">
                                <label class="label mal-text" for="text4b">{{$t('select_local_body')}}</label>
                                <div class="form-check mb-1 col-4" v-for="item in t_local_body_list"
                                    :set="t_panj_id = 'flexRadioDefaultt' + item.id" :value="item.id"
                                    v-bind:key="item.id">
                                    <Field :disabled="disable_all" class="form-check-input" type="radio"
                                        name="flexRadioDefaultt" :id="t_panj_id" v-model="t_local_body_type"
                                        :value="item.id" />
                                    <label class="form-check-label" :for="t_panj_id">
                                        {{
                                        locale === 'en' ? item.name :
                                            locale === 'ml' ? item.name_mal :
                                            locale === 'ta' ? (item.name_ta || item.name) :
                                            locale === 'kn' ? (item.name_kn || item.name) :
                                            item.name
                                        }}
                                    </label>
                                </div>
                            </div>
                            <ErrorMessage name="t_panjayath" class="error-feedback" />
                        </div>

                        <!-- Updated Panchayath selection for temporary address -->
                        <div class="form-group boxed"
                            v-if="t_country == '91' && (t_state == '94' || t_state == '529' || t_state == '541') && t_district && t_panchayaths.length">
                            <div class="input-wrapper">
                                <label class="label mal-text" for="t_panchayath">
                                    {{$t('select_panchayath_type')}}
                                </label>
                                <Field :disabled="disable_all" as="select" class="form-control custom-select"
                                    v-model="t_selectedPanchayath" name="t_panchayath" id="t_panchayath"
                                    @change="onTPanchayathChange">
                                    <option value="">{{$t('select_panchayath_placeholder')}}</option>
                                    <option v-for="p in t_panchayaths" :key="p.id" :value="p.id">{{
                                    locale === 'en' ? p.name :
                                        locale === 'ml' ? p.name_mal :
                                        locale === 'ta' ? (p.name_ta || p.name) :
                                        locale === 'kn' ? (p.name_kn || p.name) :
                                        p.name
                                    }}</option>
                                </Field>
                            </div>
                            <ErrorMessage name="t_panchayath" class="error-feedback" />
                        </div>

                        <div class="form-group boxed" v-if="t_selectedPanchayath && t_wards.length">
                            <div class="input-wrapper">
                                <label class="label mal-text" for="t_ward">{{$t('select_ward')}}</label>
                                <Field :disabled="disable_all" as="select" class="form-control custom-select"
                                    v-model="t_selectedWard" name="t_selectedWard" id="t_ward">
                                    <option value="">{{$t('select_ward')}}</option>
                                    <option v-for="w in t_wards" :key="w.id" :value="w.id">{{
                                    locale === 'en' ? w.name :
                                        locale === 'ml' ? w.name_mal :
                                        locale === 'ta' ? (w.name_ta || w.name) :
                                        locale === 'kn' ? (w.name_kn || w.name) :
                                        w.name
                                    }}</option>
                                </Field>
                            </div>
                            <ErrorMessage name="t_selectedWard" class="error-feedback" />
                        </div>
                    </div>

                    <hr class="hr-line">

                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="label mal-text" for="text4b">{{$t('house_status')}}</label>
                            <Field :disabled="disable_all" as="select" class="form-control custom-select"
                                v-model="house_status" name="house_status" id="select4">
                                <option v-for="item in home_type" :value="item.id" v-bind:key="item.id">
                                    {{
                                    locale === 'en' ? item.name :
                                        locale === 'ml' ? item.name_mal :
                                        locale === 'ta' ? (item.name_ta || item.name) :
                                        locale === 'kn' ? (item.name_kn || item.name) :
                                        item.name
                                    }}</option>
                            </Field>
                        </div>
                        <ErrorMessage name="house_status" class="error-feedback" />
                    </div>

                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="label mal-text" for="text4b">{{$t('vehicle_status')}}</label>
                            <Field :disabled="disable_all" as="select" class="form-control custom-select"
                                v-model="vehicle_status" name="vehicle_status" id="select4">
                                <option v-for="item in vehicle_details" :value="item.id" v-bind:key="item.id">
                                    {{
                                    locale === 'en' ? item.name :
                                        locale === 'ml' ? item.name_mal :
                                        locale === 'ta' ? (item.name_ta || item.name) :
                                        locale === 'kn' ? (item.name_kn || item.name) :
                                        item.name
                                    }}</option>
                            </Field>
                        </div>
                        <ErrorMessage name="vehicle_status" class="error-feedback" />
                    </div>
                    <b class="text-danger center">{{this.message}}</b>  

                    <div class="transparent pt-3" v-if="currentUser.id == profile.user_id">
                        <button class="btn btn-primary btn-block btn-lg" :disabled="loading">
                            <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                            <span>{{ $t('save_next') }}</span>
                        </button>
                    </div>
                    <div class="transparent pt-3" v-if="currentUser.id != profile.user_id">
                        <button type="button" @click="goToNextPage" class="btn btn-primary btn-block btn-lg"
                            :disabled="loading">
                            <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                            <span>{{ $t('next') }}</span>
                        </button>
                    </div>
                </Form>
            </div>
        </div>
    </div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import UserService from "../../services/user.service";

export default {
    setup() {
        const { locale } = useI18n();
        return { locale };
    },
    name: 'Basic Info',
    components: {
        Form,
        Field,
        ErrorMessage,
    },
    data() {
        const nameRegex = /^[a-zA-Z0-9&._-\s]*$/g;
        const schema = yup.object().shape({
            name: yup.string().matches(nameRegex, this.$t('name_regex')).required(this.$t('name_required')),
            mobile_number: yup.string()
                .min(7, this.$t('mobile_number_length')) // Minimum 7 digits for international numbers
                .max(13, this.$t('mobile_number_length')) // Maximum 13 digits
                .required(this.$t('mobile_number_required')),
            whatsapp_number: yup.string()
                .min(7, this.$t('mobile_number_length')) // Minimum 7 digits for international numbers
                .max(13, this.$t('mobile_number_length')) // Maximum 13 digits
                .required(this.$t('mobile_number_required')),
            blood_group: yup.string().required(this.$t('blood_group_required')),
            blood_donation_willing: yup.string().required(this.$t('blood_donation_required')),
            current_location_type: yup.string().required(this.$t('current_location_required')),
            outside_state: yup.string().when('current_location_type', {
                is: 'outside_state',
                then: yup.string().required(this.$t('select_state_required'))
            }),
            abroad_country: yup.string().when('current_location_type', {
                is: 'abroad',
                then: yup.string().required(this.$t('select_country_required'))
            }),
            abroad_city: yup.string().when('current_location_type', {
                is: 'abroad',
                then: yup.string().when('abroad_country', {
                    is: (val) => val && val !== '',
                    then: yup.string().required(this.$t('select_abroad_city_required'))
                })
            }),
            house_name: yup.string().required(this.$t('house_name_required')),
            country: yup.string().required(this.$t('country_required')),
            house_status: yup.string().required(this.$t('house_status_required')),
        });

        return {
            loading: false,
            message: "",
            schema,
            country_code: "91",
            country_code_whatsapp: "91",
            mobile_number: '',
            whatsapp_number: '',
            place: null,
            blood_group: '',
            blood_donation_willing: '',
            last_blood_donation_date: '',
            current_location_type: '',
            current_cluster: '',
            outside_state: '',
            outside_district: '',
            abroad_country: '',
            abroad_city: '',
            abroad_city_list: [],
            india_state_list: [],
            abroad_country_list: [],
            email: null,
            name: null,
            profile_image: null,
            profile_file: null,
            years: [],
            days: [],
            local_body_list: [],
            t_local_body_list: [],
            local_body_type: 827,
            t_local_body_type: 827,
            current_user_profile: null,
            profile: [],
            country_list: [],
            country_code_list: [],
            state_list: [],
            district_list: [],
            t_country_list: [],
            t_state_list: [],
            t_district_list: [],
            home_type: [],
            vehicle_details: [],
            blood_group_list: [],
            disable_all: false,
            nri_status: '',
            house_name: '',
            post_office: '',
            pin_code: '',
            country: '',
            state: '',
            district: '',
            panjayath: '',
            t_house_name: '',
            t_post_office: '',
            t_pin_code: '',
            t_country: '',
            t_state: '',
            t_district: '',
            t_panjayath: '',
            vehicle_status: '',
            house_status: '',
            same_adress: false,
            loading_list: false,

            // Panchayath/ward data for permanent address
            panchayaths: [],
            wards: [],
            selectedPanchayath: null,
            selectedWard: null,

            // Panchayath/ward data for temporary address
            t_panchayaths: [],
            t_wards: [],
            t_selectedPanchayath: null,
            t_selectedWard: null,
        };
    },

    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        maxMobileLength() {
            // Return 10 for India (country code 91), 13 for others
            return this.country_code === "91" ? 10 : 13;
        },
        maxWhatsappLength() {
            // Return 10 for India (country code 91), 13 for others
            return this.country_code_whatsapp === "91" ? 10 : 13;
        }
    },

    watch: {
        country_code(newVal, oldVal) {
            if (newVal !== oldVal && this.mobile_number) {
                // Re-validate mobile number when country code changes
                this.validateMobileNumber();
            }
        },
        country_code_whatsapp(newVal, oldVal) {
            if (newVal !== oldVal && this.whatsapp_number) {
                // Re-validate WhatsApp number when country code changes
                this.validateWhatsappNumber();
            }
        }
    },

    mounted() {
        if (!this.currentUser) {
            location.replace('/');
        }
        this.loading_list = true;
        this.current_user_profile = {};

        this.getComboboxValues('COUNTRY');
        this.getComboboxValues('DISTRICT_KERALA');
        this.getComboboxValues('STATES_INDIA');
        this.getComboboxValues('HOME_TYPE');
        this.getComboboxValues('VEHICLE_DETAILS');
        this.getComboboxValues('Blood_Group');
        this.getComboboxValues('COUNTRY_CODE');
        this.getProfile();
        this.$root.updateParent(this.$t("bio_data"));

        var j = 1;
        for (var i = 2022; i >= 1920; i--) {
            if (j <= 31) {
                this.days.push(j);
                j++;
            }
            this.years.push(i);
        }
    },

    methods: {
        switchLanguage(lang) {
            this.$i18n.locale = lang;
        },
        validateMobileInput(event, type = 'mobile') {
            let value = event.target.value;
            // Remove any non-digit characters
            value = value.replace(/[^0-9]/g, '');
            
            // Remove leading zeros
            if (value.charAt(0) === '0') {
                value = value.slice(1);
            }
            
            // Get max length based on country code
            const maxLength = type === 'mobile' ? this.maxMobileLength : this.maxWhatsappLength;
            
            // Limit to max length
            if (value.length > maxLength) {
                value = value.slice(0, maxLength);
            }
            
            // Update the input field value immediately
            event.target.value = value;
            
            // Update the model value
            if (type === 'mobile') {
                this.mobile_number = value;
            } else {
                this.whatsapp_number = value;
            }
            
            // Force update to ensure reactivity
            this.$forceUpdate();
        },
        validateMobileNumber() {
            // Re-validate mobile number based on current country code
            let value = this.mobile_number.toString();
            value = value.replace(/[^0-9]/g, '');
            
            if (value.charAt(0) === '0') {
                value = value.slice(1);
            }
            
            const maxLength = this.maxMobileLength;
            if (value.length > maxLength) {
                value = value.slice(0, maxLength);
            }
            
            this.mobile_number = value;
        },
        validateWhatsappNumber() {
            // Re-validate WhatsApp number based on current country code
            let value = this.whatsapp_number.toString();
            value = value.replace(/[^0-9]/g, '');
            
            if (value.charAt(0) === '0') {
                value = value.slice(1);
            }
            
            const maxLength = this.maxWhatsappLength;
            if (value.length > maxLength) {
                value = value.slice(0, maxLength);
            }
            
            this.whatsapp_number = value;
        },
        async getProfile() {
            var data = {
                id: this.$route.params.id
            }
            UserService.authPostRequest('get-profile', data).then(
                async (response) => {
                    this.profile = response.data.data.list;
                    if (this.profile.user_id != this.currentUser.id) {
                        this.disable_all = true;
                        this.$root.updateParent(this.profile.name + " യുടെ ബയോ ഡാറ്റ");
                    }

                    // Set all the existing profile data
                    this.name = this.profile.name;
                    this.dob = this.profile.dob ? this.profile.dob : '';
                    if (this.profile.dob) {
                        var dob_ = new Date(this.profile.dob);
                        this.dob_year = dob_.getUTCFullYear();
                        this.dob_month = dob_.getUTCMonth() + 1;
                        this.dob_day = dob_.getUTCDate();
                    } else {
                        this.dob_year = null;
                        this.dob_month = null;
                        this.dob_day = null;
                    }

                    this.country_code = this.profile.country_code;
                    this.mobile_number = this.profile.mobile;
                    this.country_code_whatsapp = this.profile.whatsapp_country_code ? this.profile.whatsapp_country_code : '91';
                    this.whatsapp_number = this.profile.whatsapp;
                    this.email = this.profile.email;
                    this.blood_group = this.profile.bloodGroup ? this.profile.bloodGroup : '';
                    this.blood_donation_willing = this.profile.blood_donation_willing ? this.profile.blood_donation_willing : '';
                    this.last_blood_donation_date = this.profile.last_blood_donation_date ? this.profile.last_blood_donation_date : '';

                    this.current_location_type = this.profile.current_location_type ? this.profile.current_location_type : '';
                    this.current_cluster = this.profile.current_cluster ? this.profile.current_cluster : '';
                    this.outside_state = this.profile.outside_state ? this.profile.outside_state : '';
                    this.outside_district = this.profile.outside_district ? this.profile.outside_district : '';
                    this.abroad_country = this.profile.abroad_country ? this.profile.abroad_country : '';
                    

                    if (this.abroad_country) {
                        this.onAbroadCountryChange(this.abroad_country);
                    }

                    this.nri_status = this.profile.nri_status ? this.profile.nri_status : '';
                    this.profile_image = this.profile.avatar != 'member.jpg' ? 'https://guide.msoftit.com/' + this.profile.avatar : null;

                    // Permanent address
                    this.house_name = this.profile.houseName ? this.profile.houseName : this.current_user_profile.houseName ? this.current_user_profile.houseName : '';
                    this.post_office = this.profile.post ? this.profile.post : this.current_user_profile.post ? this.current_user_profile.post : '';
                    this.pin_code = this.profile.pinCode ? this.profile.pinCode : this.current_user_profile.pinCode ? this.current_user_profile.pinCode : '';
                    this.country = this.profile.country ? this.profile.country : this.current_user_profile.country ? this.current_user_profile.country : '';
                    this.abroad_city = this.profile.abroad_city ? this.profile.abroad_city : '';
                    this.state = this.profile.state ? this.profile.state : this.current_user_profile.state ? this.current_user_profile.state : '';
                    if (this.state == '529') {
                        this.getComboboxValues('DISTRICT_KERALA', 529, false);
                    }
                    if (this.state == '541') {
                        this.getComboboxValues('DISTRICT_KERALA', 541, false);
                    }
                    this.district = this.profile.district ? this.profile.district : this.current_user_profile.district ? this.current_user_profile.district : '';
                    if (this.district) {
                        this.getComboboxValues('Local_Body_Type', null, false);
                        await this.fetchPanchayaths(this.profile.district_id, this.profile.unit_id);
                    }
                    this.local_body_type = this.profile.localBodyType ? parseInt(this.profile.localBodyType) : '';

                    // Set panchayath and ward from profile if available
                    this.selectedPanchayath = this.profile.panchayath_id ? this.profile.panchayath_id : null;
                    this.selectedWard = this.profile.cluster_id ? this.profile.cluster_id : null;

                    if (this.selectedPanchayath) {
                        await this.fetchWards(this.selectedPanchayath,this.profile.unit_id);
                    }

                    // Temporary address
                    this.current_user_profile = [];
                    this.same_adress = this.profile.same_adress == "0" ? false : this.current_user_profile.same_adress == "0" ? false : true;

                    this.t_house_name = this.profile.t_houseName ? this.profile.t_houseName == "1" ? this.profile.houseName : this.profile.t_houseName : this.current_user_profile.t_houseName ? this.current_user_profile.t_houseName : '';
                    this.t_post_office = this.profile.t_post ? this.profile.t_post : this.current_user_profile.t_post ? this.current_user_profile.t_post : '';
                    this.t_pin_code = this.profile.t_pinCode ? this.profile.t_pinCode : this.current_user_profile.t_pinCode ? this.current_user_profile.t_pinCode : '';
                    this.t_country = this.profile.t_country ? this.profile.t_country : this.current_user_profile.t_country ? this.current_user_profile.t_country : '';

                    this.t_state = this.profile.t_state ? this.profile.t_state : this.current_user_profile.t_state ? this.current_user_profile.t_state : '';
                    if (this.t_state == '529') {
                        this.getComboboxValues('DISTRICT_KERALA', 529, true);
                    }
                    if (this.t_state == '541') {
                        this.getComboboxValues('DISTRICT_KERALA', 541, true);
                    }
                    this.t_district = this.profile.t_district ? this.profile.t_district : this.current_user_profile.t_district ? this.current_user_profile.t_district : '';
                    if (this.t_district) {
                        const selectedDistrict = this.t_district_list.find(item => item.id === this.t_district);
                        this.getComboboxValues('Local_Body_Type', null, true);
                        if(selectedDistrict){
                            await this.fetchTPanchayaths(selectedDistrict.item_value);
                        }
                    }
                    this.t_local_body_type = this.profile.t_localBodyType ? parseInt(this.profile.t_localBodyType) : this.current_user_profile.t_localBodyType ? parseInt(this.current_user_profile.t_localBodyType) : '';

                    // Set temporary panchayath and ward from profile if available
                    this.t_selectedPanchayath = this.profile.t_panchayath_id ? this.profile.t_panchayath_id : null;
                    this.t_selectedWard = this.profile.t_ward_id ? this.profile.t_ward_id : null;

                    if (this.t_selectedPanchayath) {
                        await this.fetchTWards(this.t_selectedPanchayath);
                    }

                    this.house_status = this.profile.house_type ? this.profile.house_type : '';
                    this.vehicle_status = this.profile.vehicle_type ? this.profile.vehicle_type : '';
                    this.loading_list = false;
                },
            );
        },

        // Permanent address methods
        async onDistrictChange() {
            this.selectedPanchayath = null;
            this.selectedWard = null;
            this.wards = [];

            this.getComboboxValues('Local_Body_Type', this.district, false);
            if (this.district) {
                await this.fetchPanchayaths(this.profile.district_id, this.profile.unit_id);
            } else {
                this.panchayaths = [];
            }
        },

        async fetchPanchayaths(districtId, unitId = null) {
            try {
                districtId = districtId?districtId:this.currentUser.district_id;
                unitId = unitId?unitId:this.currentUser.unit_id;
                const response = await fetch(`https://guide.msoftit.com/api/location/panchayaths?district_id=${districtId}&unit_id=${unitId}&from=biodata`);
                const data = await response.json();
                this.panchayaths = data.data.panchayaths;
            } catch (e) {
                console.error('Error fetching panchayaths:', e);
                this.panchayaths = [];
            }
        },

        async fetchWards(panchayathId, unitId = null) {
            try {
                const response = await fetch(`https://guide.msoftit.com/api/location/wards?panchayath_id=${panchayathId}&unit_id=${unitId}&from=biodata`);
                const data = await response.json();
                this.wards = data.data.wards;
            } catch (e) {
                console.error('Error fetching wards:', e);
                this.wards = [];
            }
        },

        async onPanchayathChange() {
            this.selectedWard = null;
            if (this.selectedPanchayath) {
                await this.fetchWards(this.selectedPanchayath, this.profile.unit_id);
            } else {
                this.wards = [];
            }
        },

        // Temporary address methods
        async onTDistrictChange() {
            this.t_selectedPanchayath = null;
            this.t_selectedWard = null;
            this.t_wards = [];
            const selectedDistrict = this.t_district_list.find(item => item.id === this.t_district);

            this.getComboboxValues('Local_Body_Type', this.t_district, true);
            if (this.t_district) {
                await this.fetchTPanchayaths(selectedDistrict.item_value);
            } else {
                this.t_panchayaths = [];
            }
        },

        async fetchTPanchayaths(districtId) {
            try {
                const response = await fetch(`https://guide.msoftit.com/api/location/panchayaths?district_id=${districtId}`);
                const data = await response.json();
                this.t_panchayaths = data.data.panchayaths;
            } catch (e) {
                console.error('Error fetching t_panchayaths:', e);
                this.t_panchayaths = [];
            }
        },

        async fetchTWards(panchayathId) {
            try {
                const response = await fetch(`https://guide.msoftit.com/api/location/wards?panchayath_id=${panchayathId}`);
                const data = await response.json();
                this.t_wards = data.data.wards;
            } catch (e) {
                console.error('Error fetching t_wards:', e);
                this.t_wards = [];
            }
        },

        async onTPanchayathChange() {
            this.t_selectedWard = null;
            if (this.t_selectedPanchayath) {
                await this.fetchTWards(this.t_selectedPanchayath);
            } else {
                this.t_wards = [];
            }
        },

        // State change handlers
        async onStateChange(stateId, isTemporary) {
            if (isTemporary) {
                this.t_district = null;
                this.t_selectedPanchayath = null;
                this.t_selectedWard = null;
                this.t_panchayaths = [];
                this.t_wards = [];
                this.getComboboxValues('DISTRICT_KERALA', stateId, true);
            } else {
                this.district = null;
                this.selectedPanchayath = null;
                this.selectedWard = null;
                this.panchayaths = [];
                this.wards = [];
                this.getComboboxValues('DISTRICT_KERALA', stateId, false);
            }
        },

        onTCountryChange(countryId) {
            this.t_state = null;
            this.t_district = null;
            this.t_selectedPanchayath = null;
            this.t_selectedWard = null;
            this.t_panchayaths = [];
            this.t_wards = [];
            if (countryId == '91') {
                this.getComboboxValues('STATES_INDIA', countryId, true);
            }
        },

        storeBasicInfo(data) {
            const formData = new FormData();
            data.t_local_body_type = this.t_local_body_type;
            data.local_body_type = this.local_body_type;
            data.same_adress = this.same_adress;
            data.blood_donation_willing = this.blood_donation_willing;
            data.last_blood_donation_date = this.last_blood_donation_date;

            data.current_location_type = this.current_location_type;
            data.current_cluster = this.current_cluster;
            data.outside_state = this.outside_state;
            data.outside_district = this.outside_district;
            data.abroad_country = this.abroad_country;
            data.abroad_city = this.abroad_city;

            // Include panchayath and ward IDs
            data.panchayath_id = this.selectedPanchayath;
            data.ward_id = this.selectedWard;
            data.t_panchayath_id = this.t_selectedPanchayath;
            data.t_ward_id = this.t_selectedWard;

            if (this.dob_year) {
                data.dob = this.dob_year.toString() + '-01-01';
            } else {
                data.dob = null;
            }

            formData.append('data', JSON.stringify(data));
            formData.append('submit_type', 'basic_info');
            formData.append('id', this.$route.params.id);
            formData.append('user_id', this.currentUser.id);

            this.loading = true;
            UserService.authPostRequest('store-profile', formData).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.loading = false;
                        this.$router.push('/bio-data/education-info/' + this.$route.params.id);
                    } else if (response.data.status == 'error') {
                        this.message = response.data.message;
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.messafe = (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },

        goToNextPage() {
            this.$router.push('/bio-data/education-info/' + this.$route.params.id);
        },

        getComboboxValues(code, id = null, t = false) {
            if (id == 541) {
                code = 'DISTRICT_TAMILNADU';
            }
            if (id == 529) {
                code = 'DISTRICT_KARNATAKA';
            }
            var data = {
                code: code,
                type_id: id
            }
            UserService.getCombobox(data).then(
                (response) => {
                    switch (code) {
                        case 'COUNTRY':
                            this.t_country_list = response.data.data.list.options;
                            // this.country_list = response.data.data.list.options;
                            this.country_list = response.data.data.list.options.filter(
                            country => country.id === 91
                            );

                            this.abroad_country_list = response.data.data.list.options;
                            break;
                        case 'STATES_INDIA':
                            if (t) {
                                this.t_state_list = response.data.data.list.options;
                            } else {
                                this.t_state_list = response.data.data.list.options;
                                this.state_list = response.data.data.list.options;
                                this.india_state_list = response.data.data.list.options;
                            }
                            break;
                        case 'DISTRICT_KARNATAKA':
                            if (t) {
                                this.t_district_list = response.data.data.list.options;
                            } else {
                                this.district_list = response.data.data.list.options;
                            }
                            break;
                        case 'DISTRICT_TAMILNADU':
                            if (t) {
                                this.t_district_list = response.data.data.list.options;
                            } else {
                                this.district_list = response.data.data.list.options;
                            }
                            break;
                        case 'DISTRICT_KERALA':
                            if (t) {
                                this.t_district_list = response.data.data.list.options;
                            } else {
                                this.district_list = response.data.data.list.options;
                            }
                            break;
                        case 'KSA_STATES':
                        case 'UAE_STATES':
                        case 'QATAR_STATES':
                        case 'BAHRAIN_STATES':
                        case 'KUWAIT_STATES':
                        case 'OMAN_STATES':
                            this.abroad_city_list = response.data.data.list.options;
                            break;
                        case 'Local_Body_Type':
                            if (t) {
                                this.t_local_body_list = response.data.data.list.options;
                            } else {
                                this.local_body_list = response.data.data.list.options;
                            }
                            break;
                        case 'HOME_TYPE':
                            this.home_type = response.data.data.list.options;
                            break;
                        case 'VEHICLE_DETAILS':
                            this.vehicle_details = response.data.data.list.options;
                            break;
                        case 'Blood_Group':
                            this.blood_group_list = response.data.data.list.options;
                            break;
                        case 'COUNTRY_CODE':
                            this.country_code_list = response.data.data.list.options;
                            this.country_code = '91';
                            break;
                        default:
                            break;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message = (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },

        async clickSameAddress(event) {
            if (event.target.checked) {
                this.same_adress = true;
                this.t_country_list = this.country_list;
                this.t_state_list = this.state_list;
                this.t_district_list = this.district_list;
                this.t_local_body_list = this.local_body_list;
                this.t_panchayaths = this.panchayaths;
                this.t_wards = this.wards;
                this.t_house_name = this.house_name;
                this.t_post_office = this.post_office;
                this.t_pin_code = this.pin_code;
                this.t_country = this.country;
                this.t_state = this.state;
                this.t_district = this.district;
                this.t_local_body_type = this.local_body_type;
                this.t_selectedPanchayath = this.selectedPanchayath;
                this.t_selectedWard = this.selectedWard;
            } else {
                this.same_adress = false;
                this.t_house_name = null;
                this.t_post_office = null;
                this.t_pin_code = null;
                this.t_country = null;
                this.t_state = null;
                this.t_district = null;
                this.t_local_body_type = 827;
                this.t_selectedPanchayath = null;
                this.t_selectedWard = null;
                this.t_panchayaths = [];
                this.t_wards = [];
                this.t_local_body_list = [];
            }
        },

        onAbroadCountryChange(countryId) {
            this.abroad_city = '';
            this.abroad_city_list = [];

            // Map country IDs to their respective state/city APIs

            // Find the selected country name to determine which API to call
            const selectedCountry = this.abroad_country_list.find(country => country.id == countryId);
            if (selectedCountry) {
                const countryName = selectedCountry.name.toLowerCase();

                if (countryName.includes('saudi') || countryName.includes('سعودي')) {
                    this.getComboboxValues('KSA_STATES');
                } else if (countryName.includes('uae') || countryName.includes('emirates') || countryName.includes('إمارات')) {
                    this.getComboboxValues('UAE_STATES');
                } else if (countryName.includes('qatar') || countryName.includes('قطر')) {
                    this.getComboboxValues('QATAR_STATES');
                } else if (countryName.includes('bahrain') || countryName.includes('بحرين')) {
                    this.getComboboxValues('BAHRAIN_STATES');
                } else if (countryName.includes('kuwait') || countryName.includes('كويت')) {
                    this.getComboboxValues('KUWAIT_STATES');
                } else if (countryName.includes('oman') || countryName.includes('عمان')) {
                    this.getComboboxValues('OMAN_STATES');
                } else {
                    // For other countries, keep the list empty so text input will be shown
                    this.abroad_city_list = [];
                }
            }
        },
    },
};
</script>

<style scoped>
.error-feedback {
    color: red;
}

.label {
    font-size: 12px !important;
}

.form-control {
    height: 30px !important;
}

.mobile-field {
    margin-top: 23px;
}

.hr-line {
    height: 8px !important;
    background-color: #1a418c;
    opacity: 75%;
}

.custom-file-upload {
    width: 30%;
    height: 100px;
}

.form-check-input:disabled~.form-check-label,
.form-check-input[disabled]~.form-check-label {
    opacity: 1 !important;
}

.listview-title {
    color: #1a418c;
    padding: 1px 0px;
    font-size: 17px;
    font-weight: 900;
}

.section-title {
    color: #1a418c;
    padding: 1px 0%;
    font-size: 17px;
    font-weight: 900;
}
</style>